import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule, ActionReducer, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { localStorageSync } from 'ngrx-store-localstorage';

import { environment } from 'environments/environment';
import { Reducers } from './root-reducer';
import { AuthEffects } from './effects/auth.effects';
import { CustomerEffects } from './effects/customer.effects';
import { AdminEffects } from './effects/admin.effects';
import { DomainEffects } from './effects/domain.effects';
import { AuthActionTypes } from './actions/auth.actions';
import { RiskAssessmentEffects } from './effects/risk-assessment.effects';
import { OwnRestrictedListEffects } from './effects/own-restricted-list.effects';
import { RecordEffects } from './effects/record.effect';
import { SearchEffects } from './effects/search.effects';
import { BillableEffects } from './effects/billable.effects';
import { DocumentEffects } from './effects/document.effects';
import { ScreeningErrorMessageComponent } from 'modules/shared/components/screening-error-message/screening-error-message.component';

const EFFECTS = [
  AuthEffects,
  CustomerEffects,
  DomainEffects,
  RiskAssessmentEffects,
  AdminEffects,
  OwnRestrictedListEffects,
  RecordEffects,
  SearchEffects,
  BillableEffects,
  DocumentEffects
];

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      { domain: 'currentDomain' },
      { error: 'screeningErrors' },
      { userPreference: 'paginationPreference' }
    ],
    rehydrate: true
  })(reducer);
}

export function clearState(reducer: any) {
  return function (state: any, action: any) {

    if (action.type === AuthActionTypes.LOGOUT) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer, clearState];


@NgModule({
  declarations: [
    ScreeningErrorMessageComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forRoot(Reducers, { metaReducers }),
    EffectsModule.forRoot(EFFECTS),
    // StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
  ],
  entryComponents: [ScreeningErrorMessageComponent]
})
export class RootStoreModule { }


